// Components==============
import { faCircle, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import React, { useRef, useState } from 'react';
import { RecordVoiceAudios } from 'utilities/RecordVoiceAudios';
import './Recording.module.scss';
// =========================

export default function Recording() {
    const [audio, setAudio] = useState('');
    const [recording, setRecording] = useState(false);
    const [recordingFinished, setRecordingFinished] = useState(false);

    function recordingDone(localFile: File) {
        const url = URL.createObjectURL(localFile);

        setAudio(url);
    }

    const [recorder] = useState(
        new RecordVoiceAudios(recordingDone, setRecording, setRecordingFinished)
    );

    function resetRecording() {
        setRecording(false);
        setRecordingFinished(false);
        setAudio('');
    }

    function recordClick() {
        if (recording) {
            recorder.stopRecord();
        } else if (recordingFinished) {
            resetRecording();
        } else {
            recorder.startRecord();
        }
    }

    const ref = useRef<HTMLAudioElement>(null);

    return (
        <div styleName="wrapper">
            {!audio ? (
                <CircleButton onClick={recordClick} color="red">
                    <FontAwesomeIcon icon={recording ? faStop : faCircle} />
                </CircleButton>
            ) : (
                <>
                    <CircleButton
                        onClick={() => ref.current?.play()}
                        color="blue"
                    >
                        <FontAwesomeIcon icon={faPlay} />
                    </CircleButton>
                    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                    <audio src={audio} ref={ref} />
                </>
            )}
        </div>
    );
}
